exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#main-bandaid[data-v-61375ec4]{float:right}.bandaid-sign[data-v-61375ec4]{margin-right:.5em;margin-left:.5em}.bandaid-sign-plus[data-v-61375ec4],.bandaid-sign[data-v-61375ec4]{line-height:normal;display:inline;font-size:1.5em;text-decoration:none;color:#0d6496!important}.bandaid-sign-neg[data-v-61375ec4]:hover,.bandaid-sign-plus[data-v-61375ec4]:hover{font-weight:900}.bandaid-sign-neg[data-v-61375ec4]{line-height:normal;display:inline;font-size:1.5em;text-decoration:none;color:#0d6496!important}#bandaid-amount[data-v-61375ec4]{color:#0d6496!important;font-weight:600;display:inline}#bandaid[data-v-61375ec4]{border-radius:25px;border:1px solid #0d6496!important;color:#0d6496!important;width:6em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61375ec4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/BandAidForAdditionals.vue
// module id = 480
// module chunks = 0